module.exports = __webpack_public_path__ + "img/food1_opt.fc5e5a94.jpg";